import { Services, isEmpty } from '@sigma-frontend-libs/commons'
import { DICTIONARIES_STATUSES } from '@sigma-legacy-libs/essentials/lib/constants'

import { generateServices, globalErrorHandler, permissionPresets } from '@/utils'

import render from './render'

export default {
  name: Services.operatorGroups,

  mixins: [
    generateServices({
      name: Services.operatorGroups,

      find: {
        defaultFilter: {
          DictionaryId: undefined,
          $scope: [ 'Dictionary' ],
          $search: undefined,
          $limit: 10
        },
        alwaysCreateFromWebSocket: true,
        alwaysRemoveFromWebSocket: true
      },

      create: {
        params: {
          query: {
            $scope: [ 'Dictionary' ]
          }
        }
      }
    })
  ],

  props: {
    dictionary: {
      type: Object,
      default: () => {
        return {}
      }
    },

    removeCallback: {
      type: Function,
      default: () => {}
    }
  },

  data() {
    return {
      search: undefined,
      showDialog: false
    }
  },

  computed: {
    canCreate() {
      return this.checkPermissions(`advanced.${Services.operatorGroups}.create`, permissionPresets.resellerUp)
    },
    canRemove() {
      return this.checkPermissions(`advanced.${Services.operatorGroups}.remove`, permissionPresets.resellerUp)
    },

    isCorrectStatus() {
      return [
        DICTIONARIES_STATUSES.ready,
        DICTIONARIES_STATUSES.compiled,
        DICTIONARIES_STATUSES.activated
      ].includes(this.dictionary.status)
    }
  },

  watch: {
    dictionary: {
      handler() {
        this.getDictionary()
      },
      deep: true
    },

    search(value) {
      if (isEmpty(value)) {
        this.restData[Services.operatorGroups].find.filter.$search = undefined
      }
    }
  },

  mounted() {
    this.getDictionary()
  },

  methods: {
    getDictionary() {
      if (this.isCorrectStatus) {
        this.restData[Services.operatorGroups].find.filter.DictionaryId = this.dictionary.id
      }
    },

    async createGroup() {
      if (this.checkPermissions(`advanced.${Services.operatorGroups}.create`, permissionPresets.resellerUp)) {
        try {
          const result = await this.rest[Services.operatorGroups].create(Object.assign({ DictionaryId: this.dictionary.id }, this.restData[Services.operatorGroups].create.data))
          if (result) {
            this.showDialog = false
          }
        } catch (error) {
          globalErrorHandler(error)
        }
      }
    },

    searchHandler() {
      this.restData[Services.operatorGroups].find.filter.$search = this.search
    }
  },

  render
}
